<template>
    <base-modal class="change-password-modal" title="Passwort ändern" style="max-width: 740px" :loading="$loading('change_password')">

        <form-element name="old_password" label="Altes Passwort" v-if="old_password_needed">
            <input type="password" class="form-control" v-model="$form.old_password"/>
        </form-element>

        <form-element name="new_password">
            <password-assistant v-model="$form.new_password" label="Neues Passwort"/>
        </form-element>

        <template #footer>
            <panel>
                <btn theme="success" label="Speichern" @click="$form.$submit"/>
                <btn theme="light" label="Abbrechen" @click="$emit('close')"/>
            </panel>
        </template>
    </base-modal>
</template>

<style>
    .change-password-modal {
        max-width: 740px !important;
    }
</style>

<script>
    import {required, requiredIf} from 'vuelidate/lib/validators';

    export default {
        props: ['id_user'],

        form: {
            scrollToError: false,

            getter: () => ({
                old_password: '',
                new_password: '',
            }),

            validations() {
                return {
                    old_password: {
                        required: requiredIf(() => this.old_password_needed),
                    },
                    new_password: {password: required},
                };
            },

            async action(data) {
                this.$loading('change_password', true);

                let response = await this.$api.post(`/user/${this.id_user}/password`, data);
                if (response.$success) {
                    this.$emit('close');
                    this.$notify.success({body: 'Passwort erfolgreich geändert!', timeout: 5});
                } else if (response.message) {
                    this.$notify.danger({body: response.message, timeout: 5});
                }

                this.$loading('change_password', false);
            },
        },

        computed: {
            old_password_needed() {
                return this.$auth.isSame(this.id_user) || !this.$is('admin');
            },
        },
    };
</script>